import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "industry-section" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "swiper-container" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["innerHTML"]

import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { useRouter } from 'vue-router';
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import type { Swiper as SwiperType } from 'swiper';

interface IndustryItem {
    icon: string;
    title: string;
    route: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'IndustrySlider',
  setup(__props) {

const router = useRouter();
const { t } = useI18n();
const modules = [Pagination, Navigation];

const industryList = ref<IndustryItem[]>([
    { 
        icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2L2 7v10l10 5 10-5V7L12 2zm0 2.7L19.4 8 12 11.3 4.6 8 12 4.7z"/>
              </svg>`,
        title: 'Cars',
        route: '/cars'
    },
    { 
        icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 15v-3c0-5.52-4.48-10-10-10S1 6.48 1 12h3c0-3.87 3.13-7 7-7s7 3.13 7 7v3h-4l5 5 5-5h-4z"/>
              </svg>`,
        title: 'Motorcycle',
        route: '/motorcycle'
    },
    { 
        icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M22 18v-2H8V4h2L7 1 4 4h2v2H2v2h4v8c0 1.1.9 2 2 2h8v2h-2l3 3 3-3h-2v-2h4z"/>
              </svg>`,
        title: 'Machinery',
        route: '/machinery'
    },
    { 
        icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6z"/>
              </svg>`,
        title: 'Lock Cylinder',
        route: '/lock-cylinder'
    },
    { 
        icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M4 15.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V5c0-3.5-3.58-4-8-4s-8 .5-8 4v10.5zm8-1.5h-1v-1h1v1zm0-2h-1V9h1v3zm0-4h-1V5h1v3z"/>
              </svg>`,
        title: 'Bullet train',
        route: '/bullet-train'
    },
    { 
        icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z"/>
              </svg>`,
        title: 'Bicycles',
        route: '/bicycles'
    },
    { 
        icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 4h-3V2h-2v2H9V2H7v2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H4V6h16v14z"/>
              </svg>`,
        title: 'Watercraft',
        route: '/watercraft'
    },
    { 
        icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z"/>
              </svg>`,
        title: 'Robots',
        route: '/robots'
    },
    { 
        icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-2-3.5l6-4.5-6-4.5v9z"/>
              </svg>`,
        title: 'Oil&Gas Control Systems',
        route: '/oil-gas-control-systems'
    },
    { 
        icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6z"/>
              </svg>`,
        title: 'Medical devices',
        route: '/medical-devices'
    },
    { 
        icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
              </svg>`,
        title: 'Signal receiving devices',
        route: '/signal-receiving-devices'
    }
]);

const bannerImages = computed(() => industryList.value);

const onSwiper = (swiper: SwiperType) => {
    // 初始化时禁用自动播放
    if (swiper.autoplay) {
        swiper.autoplay.stop();
    }
};

const handleClick = (route: string): void => {
    router.push(route);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)('IndustrySlider.title')), 1),
    _createElementVNode("div", _hoisted_3, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "swiper-button-prev custom-button" }, [
        _createElementVNode("svg", {
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor"
        }, [
          _createElementVNode("path", {
            d: "M15 19l-7-7 7-7",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        ])
      ], -1)),
      _createVNode(_unref(Swiper), {
        modules: modules,
        "slides-per-view": 1,
        "space-between": 20,
        observer: true,
        "observer-parents": true,
        speed: 600,
        pagination: {
                    clickable: true,
                    dynamicBullets: true
                },
        navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                    disabledClass: 'swiper-button-disabled'
                },
        breakpoints: {
                    320: {
                        slidesPerView: 1.2,
                        spaceBetween: 10
                    },
                    480: {
                        slidesPerView: 2.2,
                        spaceBetween: 15
                    },
                    768: {
                        slidesPerView: 2.5,
                        spaceBetween: 20
                    },
                    1024: {
                        slidesPerView: 3.2,
                        spaceBetween: 20
                    },
                    1280: {
                        slidesPerView: 3.5,
                        spaceBetween: 25
                    }
                },
        class: "industry-swiper"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(industryList.value, (item, index) => {
            return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: index }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "industry-item",
                  onClick: ($event: any) => (handleClick(item.route))
                }, [
                  _createElementVNode("div", {
                    class: "icon-wrapper",
                    innerHTML: item.icon
                  }, null, 8, _hoisted_5),
                  _createElementVNode("p", null, _toDisplayString(_unref(t)(`IndustrySlider.items.${item.title.toLowerCase().replace(/&/g, '').replace(/\s+/g, '')}.title`)), 1)
                ], 8, _hoisted_4)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "swiper-button-next custom-button" }, [
        _createElementVNode("svg", {
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor"
        }, [
          _createElementVNode("path", {
            d: "M9 5l7 7-7 7",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        ])
      ], -1))
    ])
  ]))
}
}

})